import { Component, OnInit, OnDestroy, Input, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';

import { CoreService } from '../core.service';
import { SettingsService } from '../settings/settings.service';
import { ProfileService } from '../profile/profile.service';
import { PlayerService } from './player.service';



import { Game, MediaEvent, Flavor } from '../app.models'


@Component({
	selector: 'app-player',
	imports: [ CommonModule ],
	templateUrl: './player.component.html',
	styleUrl: './player.component.scss'
})
export class PlayerComponent {

	@Input() id: string; get element_id(){ return `player_${this.id}` }
	get is_selected() { return this.player.selected_player_id == this.id; }

	constructor(
		public core: CoreService,
		public profile: ProfileService,
		public settings: SettingsService,
		public player: PlayerService,
	){ this.type = this.settings.player_type; }

	aspect_ratio: number = 9/16;
	type: string;
	url: string = null; //Currently playing media url
	tv24all_url: string = null; //Currently playing media's castable url

	change_type( type ){
		if( this.type == type ) return;
		let last_url = this.url;

		this.destroy();
		this.type = type;
		this.init();

		if( last_url )
			this.play( last_url )
	}

	//Lifetime Logic

	subscriptions: any[] = [];
	ngOnInit(){
		this.player.register( this );

		setTimeout(() => { //To not confuse Angular: ExpressionChangedAfterItHasBeenCheckedError
			this.init()
		}, 0);

	}
	ngOnDestroy(){
		this.player.unregister( this );

		for( let sub of this.subscriptions )
			sub.unsubscribe();

		this.destroy();
	}


	//Assigned Media
	media_event = null;
	get media_event_id() { return this.media_event && this.media_event.id } // = null;
	//get media_event(){ return MediaEvent.INSTANCES[this.media_event_id]; }
	//set media_event(me){ this.media_event_id = me && me.id || me; }

	flavor = null;
	get flavor_id(){ return this.flavor && this.flavor.id; }

	//flavor_id = null;
	//get flavor(){ return Flavor.INSTANCES[this.flavor_id]; }
	//set flavor(f){ this.flavor_id = f && f.id || f; }

	async assign( media_event, flavor ){
		this.destroy();

		this.media_event = media_event;
		this.flavor = flavor;

		let payload = {
			"media_event_id": this.media_event_id,
			"flavor_id": this.flavor_id,
		};

		if( this.profile.is_premium ){
			if( this.profile.premium_sig === null ){
				this.message( `Loading Premium...`, `Running premium code verficiation.` );
				await this.profile.maintain_premium_sig( true )
			}
			payload["token"] = this.profile.premium_sig;
		}

		this.message(`Loading ${this.media_event.title}...`, this.flavor.name);
		let response = await this.core.json_request("POST", "/api/v2/generate_stream_info", payload, { withCredentials: true });

		if( !response.ok ){
			let error_text = ( response.json ? response.json['message'] : response.body ) || 'Try again later!';
			if( response.headers.get('content-type')[0].startsWith("text/html") )
				error_text = "Unexpected Error!";

			this.message( `Loading ${this.media_event.title} failed!`, error_text );
			return;
		}

		if( response.json['wait'] ){
			this.message('Warming up!', 'Running a health check...');
			this.health_check_init( response.json['url'], true );
			return;
		}

		if( response.json['tv24all_cast'] ){
			this.tv24all_url = response.json['tv24all_cast'];
		}

		this.play( response.json['url'] );

	}









	//Message with clean transition
	message_text: string = null;
	message_subtext: string = null;
	message_shown: boolean = false;
	message_clear_timeout = null;

	message( text = null, subtext = null ){
		if( this.message_clear_timeout )
			clearTimeout( this.message_clear_timeout );

		this.message_shown = !!( text || subtext )
		if( this.message_shown ){
			this.message_text = text;
			this.message_subtext = subtext;
		} else {
			//If both values are false, these will be removed via a transitionend,
			//but we will queue a fallback just in case
			this.message_clear_timeout = setTimeout(() => {
				this.message_text = text;
				this.message_subtext = subtext;
			}, 5000);
		}
	}
	message_clear_on_transition_end() {
		if( this.message_clear_timeout )
			clearTimeout( this.message_clear_timeout );

		if( this.message_shown ) return;
		this.message_text = null;
		this.message_subtext = null;
	}

	//
	// Generic Player Logic
	// - not dependant on the player type
	//
	delayed_start_interval = null;
	init(){
		this[`${this.type}_init`]()

	}

	get ready(){
		return this[`${this.type}_ready`];
	}
	play( url ){
		if( this.delayed_start_interval )
			clearInterval( this.delayed_start_interval );

		this.message();
		if( this.ready ){
			this.url = url;
			this[`${this.type}_play`]( url )
			return;
		}

		this.message(
			"Loading Video Player...",
			"This shouldn't take long, if it does, check your internet connection!"
		);
		this.init();
		this.delayed_start_interval = setInterval( () => {
			if ( this.ready )
				this.play( url )
		}, 100 );
	}
	stop(){
		if( this.delayed_start_interval )
			clearTimeout( this.delayed_start_interval );
		this.message();
		this.health_check_init( null, false );
		this.url = null;
		this[`${this.type}_stop`]()
	}
	destroy(){
		this.tv24all_url = null;
		try      { this.stop() }
		catch(e) { console.error("Graceful Stop failed:", e); }
		try      { this[`${this.type}_destroy`](); }
		catch(e) {
			let el = document.getElementById( this.element_id );
			if( el ) el.innerHTML = "";
		}
	}
	resize(){
		if( this[`${this.type}_resize`] ){ //Not Every player needs manual resizing.
			let newWidth  = document.getElementById( this.element_id ).parentElement.offsetWidth;
			let newHeight = 2 * Math.round( newWidth*(this.aspect_ratio)/2 );
			this[`${this.type}_resize`]( newHeight, newWidth );
		}
	}
	unmute(){
		this.player.should_play_muted = false;
		if( this[`${this.type}_player`] && this[`${this.type}_player`]['unmute'] ){
			this[`${this.type}_player`]['unmute']();
		} else {
			try {
				let video = document.getElementById( this.element_id ).querySelector("video");
				video.removeAttribute("muted");
			} catch(e) {}
		}
	}
	is_playing(){
		return this[`${this.type}_is_playing`]()
	}





	//onLoad(){
		//aclibTimeout = null;
		/*if( window['aclib'] && !this.pl.with_ads ){
			console.log("Will run ad in 15 seconds:")
			this.pl.with_ads = true;

			if( this.aclibTimeout !== null )
				clearTimeout( this.aclibTimeout );

			this.aclibTimeout = setTimeout(() => {
				window['aclib'].runPop({ zoneId: '7728366' });
				this.aclibTimeout = null;
			}, 15 * 1000);
		}*/
	//}

	//turbo stuff
	/*
	liveDistance: number = null;
	turboActive:  boolean = false; turboToggle(){ this.turboActive = !this.turboActive }
	turboCapable: boolean = false;

	mediaDuration: number = null;
	setMediaDurationFromRequest( http ){
		let text = http.responseText;

		let d = 0;

		if( !text.match(/\n#EXT-X-ENDLIST\n*$/g) )
			for( let m of text.matchAll(/\n#EXTINF:([^,]+),/g) )
				d += +m[1];

		this.turboCapable = !!d;
		if( !d ) return

		let ct = this.pl.getCurrentTime();
		this.mediaDuration = d;
		if( ct && this.pl.isPlaying() )
			this.liveDistance = d - ct;
		else
			this.liveDistance = null;

	}*/











	// *********
	// -- SHAKA STUFF:
	// **********
	shaka:    any = null; //The library object: If null, library is not pollyfilled
	shaka_ui: any = null; //The UI we have to attach: If null, ui is not drawn.
	shaka_player: any = null;
	shaka_ready: boolean = false;
	shaka_init(){
		if( !window['shaka'] ){
			//Since load script will not load the same thing twice,
			//it can also be used as a delay method!
			this.core.load_scripts(
				"/assets/shaka/shaka-player.ui.js"
			).subscribe(()=>{
				setTimeout(()=>{ this.shaka_init(); }, 10)
			})
			return;
		}

		if( !this.shaka ){
			this.shaka = window['shaka'];

			// Install built-in polyfills to patch browser incompatibilities.
			this.shaka.polyfill.installAll();

			// Check to see if the browser supports the basic APIs Shaka needs.
			if( !this.shaka.Player.isBrowserSupported() ){
				// This browser does not have the minimum set of APIs we need.
				this.message(
					"Browser Does not support shaka player.",
					"Choose another player in the settings!"
				);
				return;
			}
		}

		let wrapper = document.getElementById( this.element_id )
		let video   = wrapper.querySelector("& > video") || document.createElement("video")

		video.setAttribute("autoplay", "true")
		video.setAttribute("crossorigin", "true")
		video.setAttribute("playsinline", "true")
		if( this.player.should_play_muted )
			video.setAttribute("muted", "true")
		wrapper.appendChild( video )

		this.shaka_player = new this.shaka.Player();
		this.shaka_ui     = new this.shaka.ui.Overlay(this.shaka_player, wrapper, video);
		this.shaka_player.addEventListener('error', (event)=>{
			let error = event.detail;
			console.error('Shaka Error code:', error.code);
		});

		this.shaka_player.attach( video ).then(()=>{
			this.shaka_ready = true;
		})
	}
	shaka_play( url ){
		let config = {
			'seekBarColors': {
				base: '#8a8a8a5e',
				buffered: '#ffffff5e',
				played: this.media_event.status == "L" ? '#ff00005e': '#4f7bff5e',
			},
		}

		if( this.profile.is_premium ){

			// Set the castReceiverAppId, Other Potential IDs: 930DEB06", "B3F2CAE7", "07AEE832" OLD SHAKA?
			config['castReceiverAppId'] = '1BA79154';

			// Enable casting to native Android Apps (e.g. Android TV Apps)
			config['castAndroidReceiverCompatible'] = true;

		}

		this.shaka_ui.configure( config );
		this.shaka_player.load( url ).catch(err=>{

			if( err['code'] != 7000 ) //Loaded/Unloaded another video mid load!
				console.error("Shaka Load ERR:", err)

		});

	}
	shaka_stop(){
		if( this.shaka_player )
			this.shaka_player.unload();
	}
	shaka_destroy(){
		this.shaka_ready = false;
		this.shaka_player.destroy();
		this.shaka_ui.destroy();
		let wrapper = document.getElementById( this.element_id );
		wrapper.innerHTML = "";

		for( let attr of [...wrapper.attributes] )
			if( attr.name.includes("shaka") )
				wrapper.attributes.removeNamedItem( attr.name );

		for( let cls of [...wrapper.classList] )
			if( cls.includes("shaka") )
				wrapper.classList.remove( cls );

		wrapper.style.cursor="unset";
	}
	shaka_is_playing(){
		if( !this.shaka_player ) return false;

		let video = this.shaka_player.getMediaElement()
		return video && !video.paused && !video.ended && video.readyState > 2;
	}

	// *********
	// -- CLAPPR STUFF:
	// **********
	clappr: any = null;
	clappr_ready: boolean = false;
	clappr_player: any = false;
	clappr_fatal_error: boolean = false;

	clappr_init(){
		if( !window['Clappr'] ){
			//Since load script will not load the same thing twice,
			//it can also be used as a delay method!
			this.core.load_scripts(
				"https://cdn.jsdelivr.net/npm/clappr@latest/dist/clappr.min.js"
			).subscribe(()=>{
				setTimeout(()=>{this.clappr_init();}, 10);
			})
			return;
		}

		if( !this.clappr ){
			this.clappr = window['Clappr'];
			let scripts = ["https://cdn.jsdelivr.net/gh/clappr/clappr-level-selector-plugin@latest/dist/level-selector.min.js"];

			if( this.profile.is_premium )
				scripts.push(...[
					"https://cdn.jsdelivr.net/npm/clappr-playback-rate-plugin@latest/lib/clappr-playback-rate-plugin.min.js",
					"https://cdn.jsdelivr.net/npm/clappr-chromecast-plugin@latest/dist/clappr-chromecast-plugin.min.js"
				]);

			this.core.load_scripts( ...scripts ).subscribe(()=>{
				this.clappr_ready = true;
			});
			return;
		}

		this.clappr_ready = true;
	}
	clappr_play( url ){
		let plugins = [];

		if( window['LevelSelector'] )
			plugins.push( window['LevelSelector'] )

		if( window['PlaybackRatePlugin'] )
			plugins.push( window['PlaybackRatePlugin'] )

		if( window['ChromecastPlugin'] )
			plugins.push( window['ChromecastPlugin'] )

		if( this.clappr_player )
			this.clappr_player.destroy();

		this.clappr_fatal_error = false;
		this.clappr_player = new this.clappr.Player({

			parentId: "#"+this.element_id, source: url,
			mimeType: url.endsWith('.mp4') ? "video/mp4" : "application/x-mpegurl",
			mute: this.player.should_play_muted,

			flushLiveURLCache: false,
			disableVideoTagContextMenu: true,
			playback: {
				autoPlay : true,
				preload: "metadata",
				controls: false,
				playInline: true, // allows inline playback when running on iOS UIWebview
				crossOrigin: true,
			},
			plugins: plugins,
			events: {
				onPlay: (e)=>{
					//this.onPlaybackStateChange.emit("playing");
					this.core.events.emit("tvbox.player.playing");
				},
				onReady: (e)=>{
					/*setTimeout(() => {
						this.pl.core.getCurrentPlayback()._hls.on('hlsLevelLoaded', (e, inf)=>{
							this.setMediaDurationFromRequest( inf.networkDetails );
						});
					}, 0);*/
				},
				onError: (e)=>{
					if( e['level'] == "FATAL" ){
						this.core.events.emit("tvbox.player.crashed");
						this.clappr_fatal_error = true;
					}
					this.player.last_player_error = e;
				}
			},

			chromecast: {
				appId: '9DFB77C0',
				contentType: url.endsWith('.mp4') ? 'video/mp4' : "application/x-mpegurl",
				media: { title: this.core.stateshot['meta']['title'] },
				poster: `https://${location.host}${this.core.site_logo}`,
			},

		});

		this.clappr_player.play();
		this.resize();
	}
	clappr_stop(){
		if( this.clappr_player ){
			this.clappr_player.stop();

			if( this.clappr_fatal_error )
				this.clappr_player.destroy();
		}
	}
	clappr_destroy(){
		if( this.clappr_player )
			this.clappr_player.destroy();

		this.clappr_ready = false;
		this.clappr_player = null;
	}
	clappr_resize( h, w ){
		if( this.clappr_player )
			this.clappr_player.resize({"height":h, "width":w});
	}
	clappr_is_playing(){
		return this.clappr_player && this.clappr_player.isPlaying()
	}


	// *********
	// -- Health Check:
	// **********

	health_check_skippable: boolean = false;
	health_check_attempts: number = 3;
	health_check_autoplay: boolean = false;
	health_check_jobs: any[] = null;
	health_check_init( url, autoplay ){
		this.health_check_skippable = false;
		this.health_check_attempts  = autoplay ? 30 : 3;
		this.health_check_autoplay  = autoplay;

		//Clear Potential Old jobs
		for( let job of this.health_check_jobs || [] ){
			if( job.timeout )
				clearTimeout( job.timeout );

			if( job.observer )
				job.observer.unsubscribe();
		}

		this.health_check_jobs = null;
		if( !url ) return;

		this.health_check_jobs = [{
			"type": "master",
			"url": url,
			"state": "Queued",
			"attempted": 0,
			"icon": "autorenew",
		}];
		this.health_check_step();
	}
	health_check_step(){
		let state_set = new Set();
		for( let job of this.health_check_jobs )
			if( job.state == "Queued" ){
				job.state = "Running"

				let ms = 0;
				if( job.attempted ) //Delay with Jitter
					ms = (job.attempted * 500) + (Math.random() * 4000)

				job.attempted += 1;
				job.timeout = setTimeout(() => {
					try {
						this[`health_check_${job.type}`]( job );
					} catch(e) {
						job.state = "Error";
						console.log( "Job Error:", e );
					}
				}, ms );
				return;
			} else state_set.add( job.state )

		if( state_set.has("Running") )
			return;

		if( !state_set.has("Error") ){
			if( !this.health_check_autoplay ){
				this.health_check_jobs[0].icon = "play_arrow";
				this.message_text    = `All OK!`;
				this.message_subtext = `Press on any of the symbols below to watch the stream.`;
				return
			}

			let url = this.health_check_jobs[0].url;
			this.health_check_init( null, false ); //Clear everything
			this.play( url );
			return;
		}

		if( !this.health_check_autoplay ){
			this.health_check_jobs[0].icon = "play_arrow";
			this.message_text    = `Issues detected during health check!`;
			this.message_subtext = `Press on any of the symbols below to try to watch the stream anyway!`;
			this.health_check_skippable = true;
			return
		}

	}
	health_check_skip(){
		if( !this.health_check_skippable ) return;

		let url = this.health_check_jobs[0].url;
		this.health_check_init( null, false ); //Clear everything
		this.play( url );
	}

	health_check_master( job ){
		job.observer = this.core.http.get( job.url, {responseType: 'text'} ).subscribe(
			(r) => {

				let is_master = false;
				for( const media of r.matchAll(/#EXT-X-STREAM-INF.*\n(.*)\n/g) ){
					is_master = true;
					let url = (new URL( media[1], job.url )).toString();
					this.health_check_jobs.push({
						"type":"media",
						"url":url,
						"state":"Queued",
						"attempted":0,
						"icon": "flaky",
					})
					this.health_check_step();
				}

				job.state = "Done";
				if( is_master ){
					this.message_text = `Checking Qualities...`;
					this.message_subtext = `Press the button below to skip this health check.`;
					this.health_check_skippable = true;
					job.icon = "skip_next";
				} else
					job.icon = "check_circle";

			}, (e) => {
				if( job.attempted < this.health_check_attempts ){
					job.state = "Queued";
					this.health_check_step();
					return
				}

				job.state = "Error"
				job.icon  = "sync_problem"
				console.log( e )

				this.message_text    = "Something went wrong!";
				this.message_subtext = "Failed connecting to stream!";
			}
		)
	}
	health_check_media( job ){
		job.observer = this.core.http.get( job.url, {responseType: 'text'} ).subscribe(
			(r) => {

				let current_keys = new Set();
				for( let j of this.health_check_jobs )
					if( j.type == "key" )
						current_keys.add( j.url );

				let is_encrypted = false;
				for( const match of r.matchAll(/#EXT-X-KEY:METHOD=AES-128,URI="([^"]*)",.*\n/g) ){
					let url = (new URL( match[1], job.url )).toString();
					if( !current_keys.has(url) ){
						current_keys.add( url );

						is_encrypted = true;
						console.log("New Key:", url )
						this.health_check_jobs.push({
							"type":"key",
							"url":url,
							"state":"Queued",
							"attempted":0,
							"icon": "lock",
						})
						this.health_check_step();

					}
				}

				job.icon  = "check_circle";
				job.state = "Done";

				if( !is_encrypted )
					this.health_check_step();

			}, (e) => {
				if( job.attempted < this.health_check_attempts ){
					job.state = "Queued";
					this.health_check_step();
					return
				}

				job.icon  = "error";
				job.state = "Error";
				this.health_check_step();
			}
		)

	}
	health_check_key( job ){
		job.observer = this.core.http.get( job.url, {responseType: 'text'} ).subscribe(
			(r) => {
				job.icon  = "lock_open";
				job.state = "Done";
				this.health_check_step();

			}, (e) => {
				if( job.attempted < this.health_check_attempts ){
					job.state = "Queued";
					this.health_check_step();
					return
				}

				job.icon  = "error";
				job.state = "Error";
				this.health_check_step();
			}
		)
	}

}
